import React from 'react';
import { get } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';
import { AccountantEntityIndex, PostProductSelectContract } from '@funnels/types';
import { FunnelGridUnit } from '@funnels/ui-components';
import {
  ContactCompanyAddress,
  ContactCompanyName,
  ContactFirstName,
  ContactLastName,
  ContactPhoneNumber,
  ContactTitle,
} from '@funnels/ui-components/PostProductSelect';
import { getPPSRelatedPartyDisplayFields } from '@funnels/utils';

interface AccountantProps extends AccountantEntityIndex {
  accountantSelectContract: PostProductSelectContract;
}

export const AccountantLayout = (props: AccountantProps) => {
  const { accountantIndex, accountantSelectContract } = props;
  const questions = get(
    { postProductSelect: [accountantSelectContract] },
    FIELD_PATHS.POST_PRODUCT_SELECT_QUESTIONS(0),
    []
  );
  const { hasTitle, hasFirstName, hasLastName, hasPhone, hasBusinessName, hasBusinessAddress } =
    getPPSRelatedPartyDisplayFields(questions);

  return (
    <>
      {hasTitle && (
        <FunnelGridUnit mb="md" size={1 / 7}>
          <ContactTitle relatedPartyIndex={accountantIndex} isOptional />
        </FunnelGridUnit>
      )}

      {hasFirstName && (
        <FunnelGridUnit mb="md" size={2 / 7}>
          <ContactFirstName relatedPartyIndex={accountantIndex} isOptional />
        </FunnelGridUnit>
      )}
      {hasLastName && (
        <FunnelGridUnit mb="md" size={2 / 7}>
          <ContactLastName relatedPartyIndex={accountantIndex} isOptional />
        </FunnelGridUnit>
      )}
      {hasPhone && (
        <FunnelGridUnit mb="md" size={2 / 7}>
          <ContactPhoneNumber relatedPartyIndex={accountantIndex} isOptional />
        </FunnelGridUnit>
      )}
      {hasBusinessName && (
        <FunnelGridUnit mb="md" size={2 / 7}>
          <ContactCompanyName label={'Business name'} relatedPartyIndex={accountantIndex} isOptional />
        </FunnelGridUnit>
      )}
      {hasBusinessAddress && (
        <FunnelGridUnit mb="md" size={2 / 7}>
          <ContactCompanyAddress relatedPartyIndex={accountantIndex} isOptional />
        </FunnelGridUnit>
      )}
    </>
  );
};
